import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Route, Router, RouterStateSnapshot, UrlSegment, UrlTree } from '@angular/router';
import { ServiciologinService } from './serviciologin.service';

@Injectable({
  providedIn: 'root'
})
export class LoginGuard  {
 
  constructor(private route:Router, private login:ServiciologinService){}
  
  canLoad(route: Route, segments: UrlSegment[]): Promise<boolean | UrlTree> {
    return this.validateSession();
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean | UrlTree> {
    return this.validateSession();
  }

  private async validateSession(): Promise<boolean | UrlTree> {
    const isAuthenticated = await this.login.onVerify();
    return isAuthenticated ? true : this.route.createUrlTree(['/Login']);
  }
}
